import store from "@/store";
import { CLEAR_ERRORMSG, LOGOUT } from "@/store/action-types";
import {
  SIGNUP_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  MFA_VERIFY_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
  DASHBOARD_ROUTE,
} from "@/router/routes";
import { resetLoaders } from "@/utils/loaders";

export const ifAuthDeny = async (to: any, from: any, next: Function) => {
  store.dispatch(CLEAR_ERRORMSG);
  resetLoaders();

  const sessionToken = store.getters.sessionToken;
  const accountData = store.getters.account.data;

  if (sessionToken == null || accountData == null) {
    if (
      to.name === SIGNUP_ROUTE ||
      to.name === FORGOT_PASSWORD_ROUTE ||
      to.name === RESET_PASSWORD_ROUTE ||
      to.name === MFA_VERIFY_ROUTE
    ) {
      return next();
    }

    if (to.name !== LOGIN_ROUTE) {
      return next({ name: LOGIN_ROUTE });
    } else {
      return next();
    }
  }

  if (store.getters.account.data && !store.getters.account.data.isEmailVerified) {
    if (to.name === EMAIL_VERIFICATION_WALL_ROUTE) {
      return next();
    } else {
      return next({ name: EMAIL_VERIFICATION_WALL_ROUTE });
    }
  }

  if (store.getters.account.data && store.getters.account.data.isEmailVerified) {
    return next({ name: DASHBOARD_ROUTE });
  }

  return next();
};

export const logoutGuard = async (to: any, from: any, next: Function) => {
  return next();
};
